/**
 * Empty landing screen for a user who is authenticated and linked to aid, but
 * whose roles grant no permission that maps to a default home (`dashboard:read`
 * or `cobrador:read`).
 *
 * It renders inside the layout, so the header and sidebar stay available and the
 * user can still reach the screens their roles do grant. It is deliberately
 * blank: this user is neither unlinked nor unauthorized, so there is no problem
 * to report — the `USER_NOT_LINKED` page is for a different condition.
 */
export function NoHomePage() {
  return null;
}
